import { createSlice } from "@reduxjs/toolkit";

import { DraftStatusType } from "@services/types/draftTypes";

export interface NoteDraftState {
  content: string;
  status: DraftStatusType;
}

const initialState: NoteDraftState = {
  content: '',
  status: null,
};

export const NoteDraftSlice = createSlice({
  name: "noteDraft",
  initialState,
  reducers: {
    setDraftContent: (state, action) => {
      state.content = action.payload
    },
    setDraftStaus: (state, action) => {
      state.status = action.payload;
    }
  }
});

export const { setDraftContent, setDraftStaus } = NoteDraftSlice.actions;

export default NoteDraftSlice.reducer;
